var globalScripts=function(){};export{globalScripts as g};